(function () {
  var STORAGE_KEY = 'hwa_recently_viewed';
  var MAX_STORED = 20;

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage unavailable (private mode, etc) - fail silently */
    }
  }

  function recordView(handle) {
    if (!handle) return;
    var arr = getStored().filter(function (h) {
      return h !== handle;
    });
    arr.unshift(handle);
    setStored(arr);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      try {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      } catch (e) {
        /* fall through to basic formatting below */
      }
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function resizeImage(url, width) {
    if (!url) return '';
    width = width || 400;
    return url.replace(/\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i, '_' + width + 'x.$1$2');
  }

  function buildImageTag(url, extraClass, alt) {
    if (!url) return '';
    var src400 = resizeImage(url, 400);
    var src800 = resizeImage(url, 800);
    return (
      '<img class="recently-viewed-hwa__image' + (extraClass ? ' ' + extraClass : '') + '"' +
      ' src="' + src400 + '"' +
      ' srcset="' + src400 + ' 1x, ' + src800 + ' 2x"' +
      ' alt="' + escapeHtml(alt) + '"' +
      ' loading="lazy" />'
    );
  }

  function buildTile(product) {
    var images = product.images || [];
    var primary = product.featured_image || images[0] || '';
    var secondary = null;
    for (var i = 0; i < images.length; i++) {
      if (images[i] && images[i] !== primary) {
        secondary = images[i];
        break;
      }
    }
    var price = formatMoney(product.price);
    return (
      '<li class="recently-viewed-hwa__item">' +
        '<a href="/products/' + product.handle + '">' +
          '<div class="recently-viewed-hwa__image-wrap">' +
            buildImageTag(primary, 'recently-viewed-hwa__image--primary', product.title) +
            (secondary ? buildImageTag(secondary, 'recently-viewed-hwa__image--secondary', '') : '') +
          '</div>' +
          '<p class="recently-viewed-hwa__title">' + escapeHtml(product.title) + '</p>' +
          '<p class="recently-viewed-hwa__price">' + price + '</p>' +
        '</a>' +
      '</li>'
    );
  }

  function init(root) {
    var currentHandle = root.getAttribute('data-current-handle');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;

    if (currentHandle) {
      recordView(currentHandle);
    }

    var handles = getStored()
      .filter(function (h) {
        return h && h !== currentHandle;
      })
      .slice(0, limit);

    if (!handles.length) {
      return;
    }

    var list = root.querySelector('[data-recently-viewed-list]');
    if (!list) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) return;
      list.innerHTML = valid.map(buildTile).join('');
      root.classList.remove('is-hidden');
    });
  }

  function run() {
    var roots = document.querySelectorAll('[data-recently-viewed-root]');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
